<template>
    <el-container style="height: calc(100vh - 80px)" class="bg-white">
        <el-header style="padding: 0px; height: auto; ">
            <!-- title部 -->
            <div class="h-12 p-4 shadow-md">システム設定 > 安全責任者管理</div>

            <!-- 検索部 -->
            <div class="p-5">
                <div class="border border-gray-300 rounded-md p-4">
                    <el-form :model="searchForm" label-width="auto">
                        <div class="flex flex-col md:flex-row gap-x-4">
                            <el-form-item label="契約会社名" class="md:w-80">
                                <CompanySelector v-model="searchForm.company_code" :isSearch=true :disabled="loginUserRole !== ROLES.SYSTEM"/>
                            </el-form-item>

                            <el-button class="w-24" type="primary"
                                @click="handleSearchButton">検索</el-button>
                        </div>
                    </el-form>

                    <div class="flex justify-end">
                        <el-button class="w-24" type="primary"
                            @click="handleAddButton">新規登録</el-button>
                    </div>
                </div>
            </div>
        </el-header>

        <!-- 主显示部 -->
        <el-main style="padding-block: 0px;" v-loading="loading">
            <!-- テーブル -->
            <div class="border border-gray-300 rounded-md p-4">
                <el-table :data="mTableData" :height="'calc(100vh - 380px)'">
                    <el-table-column label="編集" width="60" align="center">
                        <template #default="scope">
                            <el-button v-if="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && (scope.row.user_role === ROLES.GENERAL || loginUserCode === scope.row.user_code))" 
                                type="primary" link @click="handleEditButton(scope.row)">
                                <el-icon>
                                    <Edit />
                                </el-icon>
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="user_code" label="コード" width="160"/>
                    <el-table-column prop="user_name" label="ユーザー名" min-width="200"/>
                    <el-table-column label="所属契約会社 - 部署" min-width="360">
                        <template #default="scope">
                            <div>{{ scope.row.company_info.company_name }} - {{ scope.row.company_info.department_name}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="telephone" label="電話番号" width="160"/>
                    <el-table-column label="ユーザー権限" width="160" align="center">
                        <template #default="scope">
                            <span v-if="scope.row.user_role === ROLES.SYSTEM">システム管理者</span>
                            <span v-else-if="scope.row.user_role === ROLES.ADMIN">契約会社管理者</span>
                            <span v-else-if="scope.row.user_role === ROLES.GENERAL">現場責任者</span>
                            <span v-else>不明</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="is_active" label="有効" width="80" align="center">
                        <template #default="scope">
                            <el-switch v-model="scope.row.is_active" @change="handleSwitchChange(scope.row)" :disabled="(loginUserRole === ROLES.SYSTEM && loginUserCode === scope.row.user_code) || (loginUserRole === ROLES.ADMIN && scope.row.user_role !== ROLES.GENERAL)"/>
                        </template>
                    </el-table-column>

                    <!-- <el-table-column label="関係現場" width="100" align="center">
                        <template #default="scope">
                            <el-button type="primary" link @click="handleDetailButton(scope.row)">
                                <el-icon>
                                    <Connection />
                                </el-icon>
                            </el-button>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="削除" width="60" align="center">
                        <template #default="scope">
                            <el-button v-if="(loginUserRole === ROLES.SYSTEM && scope.row.user_code !== loginUserCode) || (loginUserRole === ROLES.ADMIN && scope.row.user_role === ROLES.GENERAL)" 
                                type="danger" link @click="handleDeleteButton(scope.row)">
                                <el-icon>
                                    <Delete />
                                </el-icon>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- ページネーション -->
            <div class="flex justify-end mt-2">
                <el-pagination v-model:current-page="mCurrentPage" v-model:page-size="mPageSize"
                    :page-sizes="[10, 20, 50]" layout="total, sizes, prev, pager, next, jumper" :total="mTotalRecords"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </el-main>

        <el-footer style="height: 20px;"> </el-footer>
    </el-container>

    <!-- 新規登録・編集ダイアログ -->
    <el-dialog v-model="dialogFormVisible" :title="form.add_update === 'add' ? 'ユーザー新規登録' : 'ユーザー編集'" width="600px" align-center>
        <el-form :model="form" :rules="rules" ref="formRef" label-width="150px">

            <el-form-item label="ユーザーコード" prop="user_code">
                <el-input v-model="form.user_code" :disabled="form.add_update === 'update'"
                    placeholder="ユーザーコードを入力" />
            </el-form-item>

            <el-form-item label="ユーザー名" prop="user_name">
                <el-input v-model="form.user_name" placeholder="ユーザー名を入力" />
            </el-form-item>

            <el-form-item label="所属契約会社" prop="company_code">
                <CompanySelector v-model="form.company_code" :disabled="loginUserRole !== ROLES.SYSTEM"/>
            </el-form-item>

            <el-form-item label="パスワード" prop="password">
                <el-input v-model="form.password" placeholder="パスワードを入力" :type="form.add_update === 'update' ? 'password': ''"/>
            </el-form-item>

            <el-form-item label="電話番号" prop="telephone">
                <el-input v-model="form.telephone" placeholder="電話番号を入力" />
            </el-form-item>

            <el-form-item label="ユーザー権限" prop="user_role">
                <el-select v-model="form.user_role" placeholder="権限を選択してください" :disabled="loginUserRole !== ROLES.SYSTEM">
                    <el-option label="システム管理者" :value="ROLES.SYSTEM" />
                    <el-option label="契約会社管理者" :value="ROLES.ADMIN" />
                    <el-option label="現場責任者" :value="ROLES.GENERAL" />
                </el-select>
            </el-form-item>

        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogFormVisible = false">キャンセル</el-button>
                <el-button type="primary" @click="handleAddUpdateSubmit(formRef)">確認</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script lang="ts">
import axios, { AxiosResponse } from 'axios';
import { ElMessage, ElMessageBox, ElPagination, ElTable, ElTableColumn } from 'element-plus';
import { defineComponent, onMounted, ref, nextTick } from 'vue';
import type { FormInstance, FormRules } from 'element-plus';
import { Delete, Edit } from '@element-plus/icons-vue';
import { ErrorCode, ResponseData, ResponseStatus } from '@/components/common/response';
import { getErrorMessage } from '@/components/common/errorMessage';
import { Operation } from '@/components/common/request';
import { UserInfo } from '@/components/models/userinfo';
import CompanySelector from '@/components/common/company-selector.vue';
import StringUtils from '@/components/common/StringUtils';
import { authService } from '@/services/authService';
import { ALL, ROLES } from '@/config/constants';
// import moment from 'moment';


export default defineComponent({
    name: 'MntUser',
    components: {
        CompanySelector,
        ElTable,
        ElTableColumn,
        ElPagination,
        Delete,
        // Plus,
        Edit,
        // Search,
        // Connection,
    },
    setup() {
        const loginUserRole = authService.getUserInfo().user_role ?? '';
        const loginUserCode = authService.getUserInfo().user_code ?? '';
        const loginUserCompanyCode = authService.getUserInfo().company_code ?? '';


        const getFlag = (value: boolean) => {
            return StringUtils.getFlag(value);
        }

        const searchForm = ref<any>({
            company_code: loginUserRole === ROLES.SYSTEM ? ALL : loginUserCompanyCode,
        });

        const form = ref<UserInfo>({
            add_update: Operation.unknow,
            user_code: '',
            user_name: '',
            telephone: '',
            company_code: '',
            company_info: {},
            password: '',
            site_info: [],
            user_role: '',
            is_active: true,
        });

        const loading = ref<boolean>(true);
        const mTableData = ref<UserInfo[]>([]);
        const mTotalPages = ref<number>(0);
        const mTotalRecords = ref<number>(0);
        const mCurrentPage = ref<number>(1);
        const mPageSize = ref<number>(10);

        const size = ref<string>('small');
        const disabled = ref<boolean>(false);
        const background = ref<boolean>(true);

        const dialogFormVisible = ref<boolean>(false);

        const formRef = ref<FormInstance>()
        const rules = ref<FormRules>({
            user_code: [
                { required: true, message: 'ユーザーコードを入力してください', trigger: 'blur' },
                { min: 1, max: 10, message: 'ユーザーコードは1〜10文字の間で入力してください', trigger: 'blur' },
                { pattern: /^[A-Za-z0-9]+$/, message: 'ユーザーコードは半角英数字で入力してください', trigger: 'blur' }
            ],
            user_name: [
                { required: true, message: 'ユーザー名を入力してください', trigger: 'blur' },
                { min: 2, max: 25, message: 'ユーザー名は2〜25文字の間で入力してください', trigger: 'blur' },
                { pattern: /^[^<>\\/|&;$#%@"'{}()[\]]+$/, message: 'ユーザー名に使用できない文字が含まれています', trigger: 'blur' }
            ],
            password: [
                { required: true, message: 'パスワードを入力してください', trigger: 'blur' },
                { min: 8, max: 20, message: 'パスワードは8〜20文字の間で入力してください', trigger: 'blur' },
                { pattern: /^[A-Za-z0-9]+$/, message: 'パスワードは半角英数字で入力してください', trigger: 'blur' }
            ],
            company_code: [
                { required: true, message: '契約会社を選択してください', trigger: 'blur' }
            ],
            telephone: [
                { required: true, message: '電話番号を入力してください', trigger: 'blur' },
                { pattern: /^[0-9]{10,13}$/, message: '電話番号は10〜13桁の数字で入力してください', trigger: 'blur' }
            ],
            user_role: [
                { required: true, message: 'ユーザー権限を選択してください', trigger: 'blur' }
            ],
        })

        /***** マウント **************************/
        onMounted(() => {
            nextTick(() => {
                getUserList();
            });
        });

        /***** ボタン **************************/
        const handleSearchButton = () => {
            getUserList();
        };

        const handleAddButton = () => {
            dialogFormVisible.value = true;
            nextTick(() => {
                formRef.value?.resetFields();
                form.value = {
                    add_update: Operation.add,
                    user_code: '',
                    user_name: '',
                    password: '',
                    telephone: '',
                    company_code: loginUserRole === ROLES.SYSTEM ? '' : loginUserCompanyCode,
                    company_info: {},
                    site_info: [],
                    user_role: loginUserRole === ROLES.SYSTEM ? '' : ROLES.GENERAL,
                    is_active: true,
                };
            });
        };

        const handleEditButton = (row: UserInfo) => {
            dialogFormVisible.value = true;
            nextTick(() => {
                formRef.value?.resetFields();
                form.value = {
                    add_update: Operation.update,
                    user_code: row.user_code,
                    user_name: row.user_name,
                    password: row.password,
                    telephone: row.telephone,
                    company_code: row.company_code,
                    company_info: row.company_info,
                    site_info: row.site_info,
                    user_role: row.user_role,
                    is_active: row.is_active,
                };
            });
        };


        const handleDetailButton = (row: UserInfo) => {
            dialogFormVisible.value = true;
            nextTick(() => {
                formRef.value?.resetFields();
                form.value = {
                    add_update: Operation.update,
                    user_code: row.user_code,
                    user_name: row.user_name,
                    telephone: row.telephone,
                    password: row.password,
                    company_info: row.company_info,
                    site_info: row.site_info,
                    user_role: row.user_role,
                    is_active: row.is_active,
                };
            });
        };


        const handleDeleteButton = (row: UserInfo) => {
            ElMessageBox.confirm('削除しますか？', '削除', {
                confirmButtonText: '削除',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                deleteUser(row);
            }).catch(() => {
            });
        };


        const handleAddUpdateSubmit = async (formEl: FormInstance | undefined) => {
            if (!formEl) return
            await formEl.validate((valid) => {
                if (valid) {
                    if (form.value.add_update === Operation.add) {
                        addUser();
                    } else if (form.value.add_update === Operation.update) {
                        updateUser(form.value);
                    }
                    dialogFormVisible.value = false;
                }
            })
        }

        const handleSwitchChange = (row: UserInfo) => {
            updateUserActive(row);
        };

        const handleSizeChange = (size: number) => {
            mPageSize.value = size;
            getUserList();
        };
        const handleCurrentChange = (page: number) => {
            mCurrentPage.value = page;
            getUserList();
        };

        /***** DB 操作 **************************/
        const apiCall = async (method: 'get' | 'post' | 'put' | 'delete', url: string, data?: any) => {
            try {
                loading.value = true;
                const res: AxiosResponse<ResponseData<UserInfo[]>> = await axios({
                    method,
                    url,
                    data,
                    params: method === 'get' ? data : undefined, // Use params only for GET requests
                });

                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    if (method !== 'get') {
                        ElMessage.success(res.data.message);
                    }
                    return res.data;
                } else {
                    ElMessage.error(res.data.message);
                    return null;
                }
            } catch (error) {
                ElMessage.error(getErrorMessage(error as Error));
                return null;
            } finally {
                loading.value = false;
            }
        };

        const getUserList = async () => {
            const data = await apiCall('get', '/api/users/search', {
                page: mCurrentPage.value,
                limit: mPageSize.value,
                company_code: searchForm.value.company_code === ALL ? '' : searchForm.value.company_code,
            });
            if (data) {
                const { total, totalPages, currentPage, data: userData } = data;
                mCurrentPage.value = currentPage!;
                mTotalPages.value = totalPages!;
                mTotalRecords.value = total!;
                mTableData.value = userData!;
            }
        };

        const addUser = async () => {
            await apiCall('post', '/api/users', form.value);
            getUserList();
        };

        const updateUser = async (row: UserInfo) => {
            await apiCall('put', `/api/users/${row.user_code}`, row);
            getUserList();
        };

        const deleteUser = async (row: UserInfo) => {
            await apiCall('delete', `/api/users/${row.user_code}`);
            getUserList();
        };

        const updateUserActive = async (row: UserInfo) => {
            await apiCall('put', `/api/users/active/${row.user_code}`, row);
            getUserList();
        };

        return {
            getFlag,
            searchForm,
            form,
            dialogFormVisible,
            loading,
            mTableData,
            mCurrentPage,
            mPageSize,
            mTotalPages,
            mTotalRecords,
            size,
            disabled,
            background,
            handleSearchButton,
            handleAddButton,
            handleEditButton,
            handleDetailButton,
            handleDeleteButton,
            handleSizeChange,
            handleCurrentChange,
            handleAddUpdateSubmit,
            handleSwitchChange,
            formRef,
            rules,
            loginUserRole,
            loginUserCode,
            ROLES,
        }
    }
});
</script>